import React from "react";

export interface NZPostAddress {
  DPID: number;
  FullAddress: string;
}

interface Props {
  postAddresses?: NZPostAddress[];
  selected?: NZPostAddress | null;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

export default function NZPostAddressSelector({ postAddresses, selected, onChange }: Props) {
  if (!postAddresses || postAddresses.length === 0) return null;

  return (
    <tr>
      <th>NZ Post Address</th>
      <td>
        <select className="form-control" onChange={onChange} value={selected?.DPID || ""}>
          <option value="">Select NZ Post Address</option>
          {postAddresses.map((addr) => (
            <option key={addr.DPID} value={addr.DPID}>
              {addr.FullAddress}
            </option>
          ))}
        </select>
      </td>
    </tr>
  );
}
